import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Column from './Column';
import useBuilderStore from '../store/useBuilderStore';

const Row = ({ row, isPreview = false, idPrefix = '', scale = 1 }) => {
  const { selectedElement, setSelectedElement, removeRow } = useBuilderStore();
  const isSelected = selectedElement?.id === row.id;

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ 
    id: `${idPrefix}${row.id}`, 
    data: { type: 'row', originalId: row.id }
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`relative group border-2 ${!isPreview ? 'mb-4' : ''} ${isDragging ? '' : 'transition-all'} ${isSelected ? 'border-indigo-400 bg-indigo-50/5' : 'border-transparent hover:border-slate-100'} cursor-move`}
      onClick={(e) => {
        e.stopPropagation();
        setSelectedElement({ type: 'row', id: row.id });
      }}
    >
      {/* Row Label (Visible on hover) */}
      <div className={`absolute -top-3 left-4 px-2 py-0.5 bg-slate-800 text-white text-[8px] font-black uppercase rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity z-50 pointer-events-none`}>
         Row
      </div>

      <div className="flex gap-0 min-h-[50px]">
        {row.columns.map((column) => (
          <Column 
            key={column.id} 
            column={column} 
            rowId={row.id} 
            isPreview={isPreview} 
            idPrefix={idPrefix} 
            scale={scale} 
          />
        ))}
      </div>
    </div>
  );
};

export default Row;
